module.exports = __webpack_public_path__ + "img/数据分析.80fd9fa4.png";